/* eslint-disable */
export default {
    TYPES: {
        PHYSICAL_AGENT: { KEY: 'Agente Externo' },
        JURIDICAL_AGENT: { KEY: 'Agente Externo' },
        PROFESSOR: { KEY: 'Professor' },
        STUDENT: { KEY: 'Aluno' },
    },
}
